<div *ngIf="state === 'ready'">
    <div class="row">
        <div class="col-11">
            <p>The list of Organization Mapping Lookups represents the available options for mapping organizations. These values are used by the installer only. Adding or editing values requires the installer to be run.</p>
        </div>
        <div class="col-1">
            <a (click)="openOrgMappingLookupUpsertPanel(0)" ngbTooltip="Add">
                <i class="fa fa-plus" style="color: blue"></i>
            </a>
        </div>
    </div>
    <hr />

    <div *ngIf="state === 'ready'" class="tcc-table-div">
        <tcc-table tableClass="table-sm small"
            [rows]="allOrgMappingLookups"
            [columns]="columns"
            [buttons]="buttons"
            (cellClick)="rowClicked($event)">
        </tcc-table>
    </div>
</div>
<tcc-loadingOverlay *ngIf="state !== 'ready'"></tcc-loadingOverlay>
